import './App.css';
import React from "react";
import {Provider} from '@shopify/app-bridge-react';
import { BrowserRouter } from "react-router-dom";
import {default as Home} from './Home'
import {default as AppExt} from "./AppExt";
import { Routes, Route} from "react-router-dom";
import {default as AppVersion} from './AppVersion'
import { ThemeProvider } from 'styled-components';
import { generateTheme } from '@cld/theme-helper';
import { MediaLib } from "./MediaLib";
import {ErrorsTable} from "./ErrorsTable"

import {default as AppContextProvider} from './AppContext';
const params = new URL(window.location.href).searchParams;
let host = params.get('host') || process.env.REACT_APP_LOCAL_HOST
let shop = params.get('shop');

function getEnvironment() {
    const host = document.location.host;
    if (host === "shopify.cloudinary.com") {
        return "production";
    } else if (host === "shopify-staging.cloudinary.com") {
        return "staging";
    }
    return "development";
}

function getBackendUrl(env) {
    switch (env) {
        case "production":
            return  "https://production-shopify-api.cloudinary.com";
        case "staging":
            return "https://staging-shopify-api.cloudinary.com";
        default:
            return "https://be.127.0.0.1.nip.io"
    }
}

function getApiKey() {
    let q = new URLSearchParams(document.location.search);
    let apiKey = q.get('apiKey');
    if (apiKey === null) {
        apiKey = process.env.REACT_APP_SHOPIFY_API_KEY
    }
    return apiKey
}

function App() {
    const env = getEnvironment()
    const backendUrl = getBackendUrl(env);
    const apiKey = getApiKey(env)
    const params = (new URL(document.location)).searchParams
    const pid = params.get('id');
    if (params.get('close') === 'true') {
        window.opener.postMessage('refresh');
        window.close();
    }
    const hasHost = host !== undefined
        const config = {apiKey: apiKey, host: host}
        return (
            <>
                <BrowserRouter>
                    {hasHost && <Provider config={config}>
                        <ThemeProvider theme={generateTheme()}>
                        <AppContextProvider backendUrl={backendUrl}>
                            <Routes>
                                <Route path="/" element={<Home shop={shop} backendUrl={backendUrl}/>} />
                                <Route path="app-ext" element={<AppExt id={pid} shop={shop} />} />
                                <Route path="errors" element={<ErrorsTable />} />
                            </Routes>
                        </AppContextProvider>
                        <AppVersion/>
                        </ThemeProvider>
                    </Provider> }
                    {!hasHost && <ThemeProvider theme={generateTheme()}>
                        <Routes>
                        <Route path="mlw" element={<MediaLib />} />
                    </Routes>
                    <AppVersion/>
                    </ThemeProvider>}
                </BrowserRouter>
            </>
        );
}

export default App;
